/**
 * @generated SignedSource<<d0a1f8d9041a244236b70617610e330f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trackingHelpers_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "trackingHelpers_user";
};
export type trackingHelpers_user$key = {
  readonly " $data"?: trackingHelpers_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"trackingHelpers_user">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "trackingHelpers_user"
};

(node as any).hash = "37349040bccda9e430d3cebe730d5bd7";

export default node;
